import PropTypes from 'prop-types';
import { motion } from 'framer-motion';
import { Check } from '@phosphor-icons/react/dist/ssr/Check';
import { firstNameOf } from '../../../utils/contactUtils';
import { formatTimePillShort } from '../../../utils/locationFormatters';

/**
 * InviteSentNotice
 *
 * The Profile's confirmation that they sent a Royale invite. On send it lands as a
 * slightly prominent centered "toast" (a frosted pill, scaled up a touch) that then
 * dissolves to a quiet, permanent system line — "✓ *Invited {first name}*" (italic)
 * with a timestamp line below (exchange-polish item 7, 2026-07-21; the chat's
 * meeting-time style, "Mon 12:55pm"). The prominent entrance only plays on send:
 * the message list's <AnimatePresence initial={false}> skips it on reload,
 * so it just reads as the settled text.
 *
 * @param {string} inviteeName - the invited person's name (the Anon); first name is shown
 * @param {string} timestamp - the invite message's send time (ISO)
 */
export const InviteSentNotice = ({ inviteeName, timestamp = null }) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
      marginBottom: 14,
    }}
  >
    <motion.div
      initial={{ opacity: 0, scale: 1.06, backgroundColor: 'rgba(237,237,240,1)' }}
      animate={{ opacity: 1, scale: 1, backgroundColor: 'rgba(237,237,240,0)' }}
      transition={{
        duration: 0.4,
        ease: 'easeOut',
        backgroundColor: { delay: 0.45, duration: 0.5 },
      }}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        padding: '7px 14px',
        borderRadius: 16,
        fontSize: 14,
        fontWeight: 500,
        color: '#8E8E93',
      }}
    >
      <Check size={15} weight="bold" color="#8E8E93" />
      <span style={{ fontStyle: 'italic' }}>Invited {firstNameOf(inviteeName)}</span>
    </motion.div>
    {timestamp && (
      <span style={{ fontSize: 13, fontWeight: 400, color: '#8E8E93', marginTop: 2 }}>
        {formatTimePillShort(timestamp)}
      </span>
    )}
  </div>
);

InviteSentNotice.propTypes = {
  inviteeName: PropTypes.string,
  timestamp: PropTypes.string,
};

export default InviteSentNotice;
